// ATL Contact Form
;(function(w, d){
	var FORM_SELECTOR = '#atl-contact-form';
	var BUTTON_SELECTOR = '.site-button';

	function init() {
		var form = d.querySelector(FORM_SELECTOR);
		if (!form) return;
		form.addEventListener('submit', handleSubmit);
	}

	function handleSubmit(event) {
		event.preventDefault();
		var form = event.target;
		var submitBtn = form.querySelector(BUTTON_SELECTOR);

		clearErrors(form);

		var errors = validate(form);
		if (Object.keys(errors).length) {
			renderErrors(form, errors);
			return;
		}

		setButtonLoading(submitBtn, true);
		setOverlay(form, true);

		send(form)
			.then(function(response){
				setButtonLoading(submitBtn, false);

				if (response && response.success) {
					var phoneInput = form.querySelector('#atl-phone-input');
					var normalizedPhone = (w.atlGetPhoneE164ForTracking && phoneInput)
						? w.atlGetPhoneE164ForTracking(phoneInput)
						: (form.querySelector('[name="phone"]') ? form.querySelector('[name="phone"]').value : '');
					// Store form data before showing success for Google Analytics tracking
					var formDataForTracking = {
						email: form.querySelector('[name="email"]') ? form.querySelector('[name="email"]').value : '',
						phone: normalizedPhone
					};

					var revealPromise = showSuccess(form, response.data && response.data.message);
					if (revealPromise && typeof revealPromise.finally === 'function') {
						revealPromise.finally(function() {
							setOverlay(form, false);
						});
					} else {
						setOverlay(form, false);
					}
					form.reset();

					resetRecaptcha(form);

					// Google Analytics tracking
					var contactId = response.data && response.data.contact_id ? response.data.contact_id : null;
					var totalValue = response.data && response.data.total_value !== undefined ? response.data.total_value : 0.1;
					trackGoogleAnalytics(contactId, formDataForTracking, totalValue);
					
					return;
				}

				// Check if there are specific field errors (including reCAPTCHA)
				if (response && response.data && response.data.errors) {
					renderErrors(form, response.data.errors);
				}
				
				var msg = response && response.data && response.data.message
					? response.data.message
					: 'Something went wrong. Please try again.';
				
				// Only show general error message if there are no field-specific errors
				if (!response || !response.data || !response.data.errors || Object.keys(response.data.errors).length === 0) {
					showError(form, msg);
				}
				setOverlay(form, false);
				resetRecaptcha(form);
			})
			.catch(function(){
				setButtonLoading(submitBtn, false);
				setOverlay(form, false);
				showError(form, 'Something went wrong. Please try again.');
				resetRecaptcha(form);
			});
	}

	function getRecaptchaResponse(form) {
		if (!w.grecaptcha || !w.grecaptcha.getResponse) {
			return '';
		}
		var el = form.querySelector('.g-recaptcha');
		var widgetId = el ? el.getAttribute('data-widget-id') : null;
		if (widgetId) {
			return w.grecaptcha.getResponse(parseInt(widgetId, 10)) || '';
		}
		return w.grecaptcha.getResponse() || '';
	}

	function resetRecaptcha(form) {
		if (!w.grecaptcha || !w.grecaptcha.reset) {
			return;
		}
		var el = form.querySelector('.g-recaptcha');
		var widgetId = el ? el.getAttribute('data-widget-id') : null;
		if (widgetId) {
			w.grecaptcha.reset(parseInt(widgetId, 10));
			return;
		}
		w.grecaptcha.reset();
	}

	function validate(form) {
		var errors = {};
		var required = [
			{ name: 'username', label: 'Full name' },
			{ name: 'email', label: 'Email' },
			{ name: 'confirm_email', label: 'Confirm email' },
			{ name: 'phone', label: 'Phone number' },
			{ name: 'message', label: 'Message' }
		];

		required.forEach(function(field){
			var input = form.querySelector('[name="' + field.name + '"]');
			if (!input || !input.value.trim()) {
				errors[field.name] = field.label + ' is required.';
			}
		});

		if (w.ATLValidation) {
			w.ATLValidation.checkNameField(form, 'username', 'Full name', errors);
			w.ATLValidation.checkEmailField(form, 'email', errors);
		}

		var email = form.querySelector('[name="email"]');

		var confirm = form.querySelector('[name="confirm_email"]');
		if (email && confirm && email.value !== confirm.value) {
			errors['confirm_email'] = 'Email addresses do not match.';
		}

		var phone = form.querySelector('[name="phone"]');
		if (phone && phone.value && phone.value.replace(/\D/g, '').length < 6) {
			errors['phone'] = 'Please enter a valid phone number.';
		}

		if (!getRecaptchaResponse(form)) {
			errors.recaptcha = 'Please complete the reCAPTCHA verification.';
		}

		return errors;
	}

	function send(form) {
		var data = new FormData(form);
		var phoneInput = form.querySelector('#atl-phone-input');

		if (phoneInput && w.intlTelInputGlobals) {
			var instance = w.intlTelInputGlobals.getInstance && w.intlTelInputGlobals.getInstance(phoneInput);
			if (instance) {
				data.append('phone-full', instance.getNumber());
				var country = instance.getSelectedCountryData();
				if (country) {
					data.append('phone-country-code', '+' + country.dialCode);
					data.append('phone-country-iso', country.iso2);
				}
			}
		}

		var recaptchaToken = getRecaptchaResponse(form);
		if (recaptchaToken) {
			data.append('g-recaptcha-response', recaptchaToken);
		}

        // Gửi thêm thông tin IP user nếu đã được detect và cache ở frontend
		try {
			var ipInfo = localStorage.getItem('atl_info_ip');
			if (ipInfo) {
				data.append('dataIpUser', ipInfo);
			}
		} catch (e) {
			console.warn('Cannot access localStorage for IP info', e);
		}

		data.append('action', 'atl_submit_contact');

		var ajaxUrl = (w.atlConfigAjax && w.atlConfigAjax.ajax_url)
			? w.atlConfigAjax.ajax_url
			: '/wp-admin/admin-ajax.php';

		return fetch(ajaxUrl, {
			method: 'POST',
			body: data
		}).then(function(res){
			return res.json();
		});
	}

	function renderErrors(form, errors) {
		Object.keys(errors).forEach(function(field){
			if (field === 'recaptcha') {
				var recaptchaError = form.querySelector('#atl-contact-recaptcha-error');
				if (recaptchaError) {
					recaptchaError.textContent = errors[field];
					recaptchaError.style.display = 'block';
					recaptchaError.style.marginTop = '10px';
					recaptchaError.style.textAlign = 'center';
				}
				return;
			}

			var input = form.querySelector('[name="' + field + '"]');
			var group = input ? input.closest('.atl_form_group') : null;
			if (!group) return;

			var errorDiv = group.querySelector('.atl-field-error');
			if (!errorDiv) {
				errorDiv = d.createElement('div');
				errorDiv.className = 'atl-field-error';
				errorDiv.style.color = '#dc3545';
				errorDiv.style.fontSize = '12px';
				errorDiv.style.marginTop = '5px';
				group.appendChild(errorDiv);
			}

			errorDiv.textContent = errors[field];
			errorDiv.style.display = 'block';

			if (input) {
				input.classList.add('atl-field-has-error');
			}
		});
	}

	function clearErrors(form) {
		form.querySelectorAll('.atl-field-error').forEach(function(el){
			el.textContent = '';
			el.style.display = 'none';
		});
		form.querySelectorAll('.atl_form_control').forEach(function(el){
			el.classList.remove('atl-field-has-error');
		});
		var msg = form.querySelector('.atl-contact-message');
		if (msg) {
			msg.remove();
		}
		var recaptchaError = form.querySelector('#atl-contact-recaptcha-error');
		if (recaptchaError) {
			recaptchaError.textContent = '';
			recaptchaError.style.display = 'none';
		}
	}

	function showSuccess(form, message) {
		// Ẩn form (chỉ ẩn form, không ẩn wrapper vì success message cũng nằm trong wrapper)
		form.style.display = 'none';

		// Hiển thị success message box (nằm trong cùng contact-form-outer)
		var formWrapper = form.closest('.contact-form-outer');
		var success = formWrapper ? formWrapper.querySelector('.atl-contact-success') : d.querySelector('.atl-contact-success');
		
		if (success) {
			if (w.atlRevealSuccessWithConsultant) {
				return w.atlRevealSuccessWithConsultant(success);
			}
			success.style.display = 'block';
			success.scrollIntoView({ behavior: 'smooth', block: 'start' });
			return Promise.resolve();
		}

		// Fallback: hiển thị message box nếu không tìm thấy success box
		var msg = createMessageBox(form, 'success');
		msg.textContent = message || 'Thank you! Your message has been sent. We will contact you soon.';
		return Promise.resolve();
	}

	function showError(form, message) {
		var msg = createMessageBox(form, 'error');
		msg.textContent = message || 'Something went wrong. Please try again.';
	}

	function createMessageBox(form, type) {
		var old = form.querySelector('.atl-contact-message');
		if (old) old.remove();

		var box = d.createElement('div');
		box.className = 'atl-contact-message';
		box.style.marginBottom = '15px';
		box.style.padding = '10px 15px';
		box.style.borderRadius = '4px';
		box.style.fontSize = '14px';
		box.style.textAlign = 'left';

		if (type === 'success') {
			box.style.backgroundColor = '#d4edda';
			box.style.color = '#155724';
			box.style.border = '1px solid #c3e6cb';
		} else {
			box.style.backgroundColor = '#f8d7da';
			box.style.color = '#721c24';
			box.style.border = '1px solid #f5c6cb';
		}

		var row = form.querySelector('.row');
		if (row && row.parentNode) {
			row.parentNode.insertBefore(box, row);
		} else {
			form.insertBefore(box, form.firstChild);
		}

		return box;
	}

	function setButtonLoading(btn, loading) {
		if (!btn) return;
		if (loading) {
			btn._text = btn.textContent;
			btn.disabled = true;
			btn.textContent = 'Sending...';
		} else {
			btn.disabled = false;
			btn.textContent = btn._text || 'Submit Question';
		}
	}

	function setOverlay(form, show) {
		var container = form.closest('.contact-form-outer') ||
			form.closest('.contact-info-section') ||
			form.closest('.section-content') ||
			form;

		if (!container) return;

		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		var overlay = container.querySelector('.atl-form-loading-overlay');
		if (!overlay) {
			overlay = d.createElement('div');
			overlay.className = 'atl-form-loading-overlay';
			overlay.innerHTML = '<div class="atl-loading-pic"><div class="loader"></div></div>';
			container.appendChild(overlay);
		}

		overlay.style.display = show ? 'flex' : 'none';
	}

	// Google Analytics tracking function
	function trackGoogleAnalytics(requestCode, formData, totalValue) {
		// Check if gtag is available
		if (typeof w.gtag === 'undefined') {
			console.log('Google Analytics gtag not available');
			return;
		}

		// Get user data from stored form data
		var userEmail = formData ? formData.email : '';
		var userPhone = formData ? formData.phone : '';
		
		// Use provided requestCode or empty string
		var finalRequestCode = requestCode || '';
		
		// Use provided totalValue or default to 0.1
		var finalTotalValue = totalValue !== undefined ? totalValue : 0.1;
		
		console.log('Tracking Google Analytics conversion (Contact Form):', {
			email: String(userEmail),
			phone: String(userPhone),
			requestCode: String(finalRequestCode),
			totalValue: finalTotalValue
		});

		// Execute custom tracking script from admin settings
		executeCustomTrackingScript(userEmail, userPhone, finalRequestCode, finalTotalValue);
	}

	// Execute custom tracking script from admin settings
	function executeCustomTrackingScript(userEmail, userPhone, requestCode, totalValue) {
		// Check if custom script is available from admin settings
		if (w.atlCustomScripts && w.atlCustomScripts.js_after_submit_contact_form) {
			var customScript = w.atlCustomScripts.js_after_submit_contact_form;
			
			// Use provided totalValue or default to 0.1
			var finalTotalValue = totalValue !== undefined ? totalValue : 0.1;
			
			// Replace placeholders with actual values, keeping the single quotes
			var scriptToExecute = customScript
				.replace(/'USER_EMAIL'/g, "'" + String(userEmail) + "'")
				.replace(/'USER_PHONE'/g, "'" + String(userPhone) + "'")
				.replace(/'REQUESTCODE'/g, "'" + String(requestCode) + "'")
				.replace(/TOTALVALUE/g, String(finalTotalValue));
			
			console.log('Executing custom tracking script (Contact Form):', scriptToExecute);
			
			try {
				// Execute the custom script
				console.log(scriptToExecute);
				eval(scriptToExecute);
			} catch (error) {
				console.error('Error executing custom tracking script (Contact Form):', error);
			}
		}
	}

	if (d.readyState === 'loading') {
		d.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})(window, document);


